module.exports = __webpack_public_path__ + "img/courses-image002.f03ce41f.jpg";